import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiErrorMessage } from "../../utils";

export const fetchQuotaUsageAsync = createAsyncThunk(
  "quota/fetchUsage",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/quota-usage");
      return response.data;
    } catch (error) {
      console.error("Failed to fetch quota usage:", error);
      return rejectWithValue(apiErrorMessage(error, "Failed to fetch quota usage"));
    }
  }
);

export const initialState = {
  quotaUsage: null,
  loading: false,
  error: null
};

export const quotaSlice = createSlice({
  name: "quota",
  initialState,
  reducers: {
    clearQuotaError: state => {
      state.error = null;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchQuotaUsageAsync.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuotaUsageAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.quotaUsage = action.payload;
        state.error = null;
      })
      .addCase(fetchQuotaUsageAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearQuotaError } = quotaSlice.actions;
export default quotaSlice.reducer;
